import { Component, Inject, Vue } from "vue-property-decorator";
import Utils from "@/vue/infrastructure/utils/helpers";
import vuescroll from "vuescroll";
import DfStore from "@/vue/domain/store/df-store";
import { CONTAINER_TYPES } from "@/vue/infrastructure/ioc/container-types";
import ServiceInterface from "@/vue/service/service-interface";
import DfProperty from "@/vue/domain/content/df-property";
import Swal from "sweetalert2";
import DfBrand from "@/vue/domain/brand/df-brand";
import DfUser from "@/vue/domain/user/df-user";

@Component({
  components: {
    DfHeaderMobile: () => Utils.externalComponent2("df-header-mobile"),
    DfFormManager: () => Utils.externalComponent2("df-form-manager"),
    DfStoreCard: () => Utils.externalComponent2("df-store-card"),
    DfErrorCard: () => import(/* webpackChunkName: 'df-error-card' */ "@/vue/components/df-page-error/df-error-card/df-error-card.vue"),
    vuescroll,
  },
})
export default class DfPageUserRegistrationComponent extends Vue {
  @Inject(CONTAINER_TYPES.ServiceInterface)
  private service!: ServiceInterface;

  private registrationData: any = {};
  private cardCheckDone = false;
  private cardRegistrationChoice = false;
  private showAlertEmail = true;
  private showAlertProcessingConent = true;

  get brand(): DfBrand {
    return this.$store.getters.brand;
  }

  get clubCardNumber(): DfUser {
    return Utils.getPropertyValue(
      this.currentUser,
      Utils.PROPERTY_USER_CAMI_CARD_NUMBER,
      "STRING"
    );
  }

  get cardCheckFields(): any {
    const camiCardNumber: DfProperty = new DfProperty("STRING", "cardNumber", "Codice Carta Club", [{ string: null }], true);
    const destinationCardNumber: DfProperty = new DfProperty("STRING", "destinationCardNumber", "Codice Carta Club", [{ string: null }], true);
    const taxCode: DfProperty = new DfProperty("STRING", "taxCode", "Codice fiscale", [{ string: null }], true);
    const firstName: DfProperty = new DfProperty("STRING", "firstName", "Nome", [{ string: null }], true);
    const lastName: DfProperty = new DfProperty("STRING", "lastName", "Cognome", [{ string: null }], true);
    const dateOfBirth: DfProperty = new DfProperty("DATE", "birthDate", "Data di nascita", [{ date: null }], true);
    const points: DfProperty = new DfProperty("NUMBER", "points", "Nr. punti", [{ number: 0 }], true);

    if (this.isTransferPoints && this.currentUser) {
      return { properties: [points, destinationCardNumber] };
    } else if (this.currentUser) {
      return { properties: [camiCardNumber] };
    } else {
      switch (this.registrationMode) {
        case Utils.REGISTRATION_MODE_SINGLE_CHECK:
          return { properties: [camiCardNumber, taxCode] };
        case Utils.REGISTRATION_MODE_FULL_CHECK:
          return { properties: [firstName, lastName, camiCardNumber, taxCode, dateOfBirth] };
        default:
          return { properties: [] };
      }
    }
  }

  get currentStore(): DfStore {
    return this.$store.getters.currentStore;
  }

  get currentUser(): DfUser {
    return this.$store.getters.user;
  }

  get showCardCheck(): boolean {
    return this.registrationMode === Utils.REGISTRATION_MODE_SINGLE_CHECK || this.registrationMode === Utils.REGISTRATION_MODE_FULL_CHECK;
  }

  get registrationMode(): string {
    const propertyValue: any = Utils.getPropertyValue(this.brand, Utils.PROPERTY_REGISTRATION_MODE, "LIST");
    return propertyValue ? propertyValue.key : Utils.REGISTRATION_MODE_STANDARD;
  }

  get isTransferPoints(): boolean {
    return this.$route.query.action === "transfer";
  }

  get isNewCard(): boolean {
    return this.$route.query.action === "newcard";
  }

  get isFirstCard(): boolean {
    return this.$route.query.action === "card";
  }

  beforeMount() {
    if (Utils.enablePrivateArea()) {
      if (this.currentUser) {
        this.cardRegistrationChoice = true;
      } else {
        this.getRegistrationData();
      }
    } else {
      this.$router.push({ name: "home-store", params: { storeAlias: this.currentStore.alias } });
    }
  }

  private saveCamiCard(callbackFunctions: any) {
    this.currentUser ? this.bindCamiCard(callbackFunctions) : this.checkCamiCard(callbackFunctions);
  }

  private bindCamiCard(callbackFunctions: any) {
    const params: any = {};
    this.cardCheckFields.properties.forEach((property: DfProperty) => {
      params[property.code] = property.values[0][property.type.toLowerCase()];
    });

    if (this.currentUser && this.isNewCard) {
      Swal.fire({
        title: this.$t("df-page-user-registration.modal.request-bind-cami-card.save.title").toString(),
        text: this.$t("df-page-user-registration.modal.request-bind-cami-card.save.body").toString(),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("df-page-user-registration.modal.request-bind-cami-card.save.ok").toString(),
        cancelButtonText: this.$t("df-page-user-registration.modal.request-bind-cami-card.save.cancel").toString(),
        input: "password",
        inputPlaceholder: this.$t("df-page-user-registration.modal.request-bind-cami-card.password").toString(),
      }).then((result) => {
        if (result.value) {
          params.password = result.value;
          this.service
            .substituteCamiCardSecured(params)
            .then(() => {
              this.$router.push({name: "account-card"}).then(() => {
                Swal.fire({
                  title: this.$t("df-page-user-registration.modal.substitute-cami-card.save.title").toString(),
                  text: this.$t("df-page-user-registration.modal.substitute-cami-card.save.body").toString(),
                  icon: "info",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: this.$t("df-page-user-registration.modal.substitute-cami-card.save.ok").toString(),
                });
              });
            })
            .catch((error: any) => {
              if (callbackFunctions.catch) {
                callbackFunctions.catch(error);
              }
              this.cardCheckDone = false;
            });
        } else {
          if (callbackFunctions.then) {
            callbackFunctions.then();
          }
        }
      });
    } else {
      this.service
        .bindCamiCard(params)
        .then(() => {
          this.$router.push({name: "account-card"}).then(() => {
            Swal.fire({
              title: this.$t("df-page-user-registration.modal.bind-cami-card.save.title").toString(),
              text: this.$t("df-page-user-registration.modal.bind-cami-card.save.body").toString(),
              icon: "info",
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.$t("df-page-user-registration.modal.bind-cami-card.save.ok").toString(),
            });
          });
        })
        .catch((error: any) => {
          if (callbackFunctions.catch) {
            callbackFunctions.catch(error);
          }
          this.cardCheckDone = false;
        });
    }
  }

  private checkCamiCard(callbackFunctions: any) {
    const params: any = {};
    this.cardCheckFields.properties.forEach((property: DfProperty) => {
      params[property.code] = property.values[0][property.type.toLowerCase()];
      if (property.code === "taxCode") {
        params[property.code] = (params[property.code] || "").toUpperCase();
      }
    });

    this.service
      .checkCamiCard(params)
      .then((response: any) => {
        Swal.fire({
          title: this.$t("df-page-user-registration.modal.check-cami-card.save.title").toString(),
          text: this.$t("df-page-user-registration.modal.check-cami-card.save.body").toString(),
          icon: "info",
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("df-page-user-registration.modal.check-cami-card.save.ok").toString(),
        }).then((result) => {
          if (callbackFunctions.then) {
            callbackFunctions.then(response);
          }

          this.registrationData = response;
          this.registrationData.properties.forEach((property: DfProperty) => {
            property.onlyNumbers = ["POSTAL_CODE"].includes(property.code);
            property.onlyLetters = ["CITY"].includes(property.code);
            if (property.type === "LIST" && property.values[0][property.type.toLowerCase()] !== null) {
              property.values[0][property.type.toLowerCase()] = property.listOptions.find((option: any) => option.key === property.values[0][property.type.toLowerCase()]);
            }

            property.readOnly = property.values[0][property.type.toLowerCase()] !== null && property.values[0][property.type.toLowerCase()] !== "";
          });
          this.cardCheckDone = true;
        });
      })
      .catch((error: any) => {
        if (callbackFunctions.catch) {
          callbackFunctions.catch(error);
        }
        this.cardCheckDone = false;
      });
  }

  private goToStorePage(store: DfStore) {
    this.$router.push({ name: "store", params: { storeAlias: store.alias } }).catch((err) => err);
  }

  private openMap() {
    window.open(`${Utils.GOOGLE_MAP_URL}${Utils.storeGoogleMapsCoordinates(this.currentStore)}`, "_blank");
  }

  private getRegistrationData() {
    this.service
      .getRegistrationData()
      .then((registrationData: any) => {
        this.registrationData = registrationData;
        this.registrationData.properties.map((property: DfProperty) => {
          property.onlyNumbers = ["POSTAL_CODE"].includes(property.code);
          property.onlyLetters = ["CITY"].includes(property.code);
          return property;
        });
      })
      .catch((error: Error) => {
        Utils.defaultApiErrorHandler(error, this, () => {
          this.getRegistrationData();
        });
      });
  }

  private saveRegistrationData(callbackFunctions: any) {
    const params: any = {
      confirmPassword: this.registrationData["confirmPassword"],
      email: this.registrationData["email"],
      password: this.registrationData["password"],
      privacyConsent: this.registrationData["privacyConsent"],
      clubCardConsent: this.registrationData["clubCardConsent"],
      storeIdentifier: this.currentStore.identifier,
      properties: (this.registrationData.properties || []).map((property: DfProperty) => {
        return {
          type: property.type,
          code: property.code,
          values: property.values.map((value: any) => {
            if (property.type === "LIST") {
              const listValue = value.list ? value.list.key : null;
              return listValue && listValue !== Utils.FAKE_VALUE ? { list: listValue } : { list: null };
            } else if (property.code === "TAX_CODE" && value.string) {
              value.string = value.string.toUpperCase();
              return value;
            } else if (property.type === "NUMBER") {
              value.number = value.number ? parseInt(value.number) : null;
              return value;
            } else {
              return value;
            }
          }),
        };
      }),
    };

    if (params.email) {
      if (this.showAlertEmail) {
        Swal.fire({
          title: this.$t("df-page-user-registration.modal.email-check.title").toString(),
          html: this.$t("df-page-user-registration.modal.email-check.body", {0: params.email}).toString(),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("df-page-user-registration.modal.email-check.ok").toString(),
          cancelButtonText: this.$t("df-page-user-registration.modal.email-check.cancel").toString(),
        }).then((result) => {
          this.showAlertEmail = false;

          if (result.value) {
            this.saveRegistrationDataProcessingConent(params, callbackFunctions);
          } else {
            if (callbackFunctions.then) {
              callbackFunctions.then();
            }
          }
        });
      } else {
        this.saveRegistrationDataProcessingConent(params, callbackFunctions);
      }
    } else {
      this.setRegistrationData(params, callbackFunctions);
    }
  }

  private saveRegistrationDataProcessingConent(params: any, callbackFunctions: any) {
    const processingConent: any = params.properties.find((property: any) => property.code === "PROCESSING_CONSENT");
    const profilingConent: any = params.properties.find((property: any) => property.code === "PROFILING_CONSENT");
    const checkProcessing:boolean = processingConent && processingConent.values[0]?.boolean === false;
    const checkprofiling:boolean = processingConent && processingConent.values[0]?.boolean === false;
    if ((checkProcessing || checkprofiling) && this.showAlertProcessingConent) {
      Swal.fire({
        title: this.$t("df-page-user-registration.modal.processing-consent.title").toString(),
        text: this.$t("df-page-user-registration.modal.processing-consent.body").toString(),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("df-page-user-registration.modal.processing-consent.ok").toString(),
        cancelButtonText: this.$t("df-page-user-registration.modal.processing-consent.cancel").toString(),
      }).then((result) => {
        this.showAlertProcessingConent = false;

        if (result.value) {
          processingConent.values[0].boolean = true;
          profilingConent.values[0].boolean = true;
        }
        this.setRegistrationData(params, callbackFunctions);
      });
    } else {
      this.setRegistrationData(params, callbackFunctions);
    }
  }

  private setRegistrationData(params: any, callbackFunctions: any) {
    this.service
      .setRegistrationData(params, {
        df_redirect_path: `${process.env.VUE_APP_REDIRECT_PATH}/punti-vendita/${this.currentStore.alias}/attivazione-account`,
        df_redirect_base_url: process.env.VUE_APP_REDIRECT_BASE_URL,
      })
      .then((response: any) => {
        if (callbackFunctions.then) {
          callbackFunctions.then(response);
        }
        Utils.setAnaliticsTraker({
          event: "user_registration",
          origin: "smt-digitalflyer-ui",
          email: this.registrationData["email"],
        });
        Swal.fire({
          title: this.$t("df-page-user-registration.modal.save.title").toString(),
          text: this.$t("df-page-user-registration.modal.save.body").toString(),
          icon: "info",
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("df-page-user-registration.modal.save.ok").toString(),
        }).then((result) => {
          if (result.value) {
            this.$router.push({ name: "home-store", params: { storeAlias: this.currentStore.alias } }).then(() => {
              this.$store.dispatch("setShowLogin", true);
            });
          }
        });
      })
      .catch((error: any) => {
        if (callbackFunctions.catch) {
          callbackFunctions.catch(error);
        }
      });
  }

  private quit() {
    if (this.currentUser) {
      this.$router.push({ name: "account-card" });
    } else {
      this.cardRegistrationChoice = false;
      this.cardCheckDone = false;
    }
  }

  private setCardRegistrationChoice(useCard: boolean) {
    this.cardRegistrationChoice = true;
    this.cardCheckDone = !useCard;
    this.registrationData.properties = this.registrationData.properties.filter((property: DfProperty) => property.code !== "CAMI_CARD_NUMBER" || useCard);
  }

  private transferPoints(callbackFunctions: any) {
    const params: any = {};
    this.cardCheckFields.properties.forEach((property: DfProperty) => {
      params[property.code] = property.values[0][property.type.toLowerCase()];
    });

    if (this.currentUser) {
      Swal.fire({
        title: this.$t("df-page-user-registration.modal.transfer-points.title").toString(),
        text: this.$t("df-page-user-registration.modal.transfer-points.body").toString(),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("df-page-user-registration.modal.transfer-points.ok").toString(),
        cancelButtonText: this.$t("df-page-user-registration.modal.transfer-points.cancel").toString(),
        input: "password",
        inputPlaceholder: this.$t("df-page-user-registration.modal.transfer-points.password").toString(),
      }).then((result) => {
        if (result.value) {
          params.password = result.value;
          this.service
            .transferCamiPoints(params)
            .then(() => {
              this.$router.push({name: "account-card"}).then(() => {
                Swal.fire({
                  title: this.$t("df-page-user-registration.modal.transfer-points.saved.title").toString(),
                  text: this.$t("df-page-user-registration.modal.transfer-points.saved.body").toString(),
                  icon: "info",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: this.$t("df-page-user-registration.modal.transfer-points.saved.ok").toString(),
                });
              });
            })
            .catch((error: any) => {
              if (callbackFunctions.catch) {
                callbackFunctions.catch(error);
              }
              this.cardCheckDone = false;
            });
        } else {
          if (callbackFunctions.then) {
            callbackFunctions.then();
          }
        }
      });
    }
  }
}
